export default "__VITE_ASSET__BxcEUy$R__"